var render = function render(){var _vm=this,_c=_vm._self._c;return _c('submit-button',{staticClass:"btn-nlcaa btn-sm ml-auto",attrs:{"form":_vm.form,"icon":"fa-envelope"},on:{"click":function($event){return _vm.save()}}},[_vm._v("Notify me when the course is available")])
}
var staticRenderFns = []

export { render, staticRenderFns }